/** Below this Ask is one column: the rail is a drawer and the compact shell takes over. */
export const ASK_NARROW = "(max-width: 991.98px)";
